import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  Input,
  Select,
  Flex,
  Text,
  Icon,
  Checkbox,
  Divider,
  List,
  Alert,
  TooltipWrapper
} from "@theorgchartdev/storybook";
import CentralizedModalContainer from "../../../../Utils/CentralizedModalContainer/CentralizedModalContainer";
import React, { useState, useEffect } from "react";
import { GetUserList, LoadDirectory, UpdateAccountMetadata } from "@/Utils/Promises";
import cx from "classnames";
import ActionListItem from "../../../../Composites/ActionListItem/ActionListItem";
import { GetWSMgr } from "@/Utils/StateLib";
import { CanAddSeats } from "../ManageUsers/Utils";
import { CheckValidGroupConfig, SetAccessGroupsToJSON } from "./Utils";
import * as StateLib from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import { QViewMgr } from "@coreapp/CoreApp/QViewMgr";
import { QAlert } from "@coreapp/CoreApp/QAlert";
import { Globals } from "@coreapp/CoreApp/Globals";
import {
  kAdminUser,
  kRWUser,
  kROUser,
  kSpecialFolders,
  enumFeaturesList
} from "@coreapp/constants";
import { appstrp } from "@coreapp/utils/appstrp";
import { getFeatureAccess } from "@/Utils/Misc";
import {
  AccountSettingsSectionRoutes,
  getAccountSettingsTestPrefix
} from "@/providers/NavigationProvider";

const accessGroupsTestPrefix = getAccountSettingsTestPrefix(
  AccountSettingsSectionRoutes.AccessGroups
);

export const GeneralOptions = [
  {
    value: "canExportExcel",
    label: "canExportExcel",
    disabled: false
  },
  {
    value: "canEditTemplates",
    label: "canEditTemps",
    disabled: false
  },
  {
    value: "privatefolderaccess",
    label: "Private Folder Access",
    disabled: false
  },
  {
    value: "pointintime",
    label: "Point In Time",
    disabled: false
  },
  {
    value: "interactiveFiltering",
    label: "Interactive filters & highlights",
    disabled: false
  }
];

const SecurityOptions = [
  {
    value: "rowLevelSecurity",
    selectKey: "rowsecprofile",
    label: "Row Level Security",
    featureKey: "RLS"
  },
  {
    value: "roleassignment",
    label: "Role Assignment",
    selectKey: "roleassignment",
    featureKey: "roleassignment"
  },
  {
    value: "uiprofile",
    label: "UI Profile",
    selectKey: "uiprofile",
    featureKey: "uiProfiles"
  }
];

const ReportingOptions = [
  {
    value: "reporting",
    label: appstr("Reporting")
  }
];

const EmptyOptions = [
  {
    label: appstr("None"),
    disabled: true,
    value: "none"
  }
];

export const GetNewGroupObj = () => {
  return {
    name: "New Access Group",
    folders: [{ name: "Masters", locked: true }]
  };
};

export const GetAllChartViews = currentChart => {
  if (!currentChart) return [];
  let chartViews = currentChart["views"];
  var unusedViews = GetUnusedViews();
  var orgViews = chartViews.concat(unusedViews);
  return orgViews.filter(function (item, pos) {
    return orgViews.indexOf(item) == pos;
  });
};

export const GetUnusedViews = () => {
  const wsMgr = GetWSMgr();
  var vm = new QViewMgr();
  vm.InitViewMgr(wsMgr);
  vm.ResetViewMgr();
  return vm.GetUnusedTemplates();
};

export const IsChartData = accountConfig => {
  let charts = accountConfig["charts"];
  return charts && charts.length > 0;
};

export const GetViewNameByID = theViewID => {
  let viewName = theViewID;
  const wsMgr = GetWSMgr();
  const ctm = wsMgr.GetChartTemplatesMgr();
  if (ctm) {
    let theChartView = ctm.FindTemplateByIDAllSets(theViewID, true)["template"];
    if (theChartView == null) {
      viewName = theViewID + " (" + appstr("Missing") + ")";
    } else {
      viewName = theChartView.GetTemplateName();
    }
  }
  return viewName;
};

export const BuildBaseCharts = (charts, theGroup, changeChart) => {
  let chartOptions = [];
  if (!charts || !theGroup) return chartOptions;
  for (let chart of charts) {
    let canAccess = theGroup ? theGroup["chartAccess"][chart["ID"]] : false;
    let option = {};
    option.value = chart["ID"];
    option.label = chart["name"];
    option.icon = canAccess ? "check" : "xmark";
    option.clickHandler = changeChart;
    chartOptions.push(option);
  }
  return chartOptions;
};

// HIGHLIGHT CURRENT LIST
export const BuildAllowedHighlightOptions = (theGroup, currentChart, clickHandler) => {
  let options = [];
  if (!currentChart || !theGroup) return options;
  let chartFilters = currentChart["highlights"];
  if (!chartFilters) return options;
  let chartID = currentChart["ID"];
  let filters = theGroup["allowedHighlights"][chartID] || [];
  if (filters == null) filters = [];
  for (let i = 0; i < filters.length; i++) {
    let theFilter = theGroup["allowedHighlights"][chartID][i];
    if (typeof theFilter === "object" && theFilter !== null && theFilter.filterName != null) {
      theFilter = theGroup["allowedHighlights"][chartID][i].filterName;
      theGroup["allowedHighlights"][chartID][i] = theFilter;
    }
    let option = {};
    option.value = theFilter;
    option.content = (
      <ActionListItem
        label={theFilter}
        labelProps={{ size: "small" }}
        actions={[
          {
            iconName: "trash-can",
            iconProps: { color: "error" },
            onClick: () => clickHandler("remove", "allowedHighlights", theFilter),
            dataTestId: `${accessGroupsTestPrefix}-modal-highlight-${theFilter}-remove-btn`
          }
        ]}
      />
    );
    options.push(option);
  }
  return options;
};

// SELECT FILTER OPTIONS
export const BuildSelectHighlightOptions = (group, currentChart, clickHandler) => {
  let filterOptions = [];
  if (!currentChart || !group) return filterOptions;
  let chartID = currentChart["ID"];
  var allowedHighlights = group["allowedHighlights"][chartID] || [];

  var chartHighlights = currentChart["highlights"];
  if (!chartHighlights) return filterOptions;
  var highlightNames = chartHighlights.map(function (highlightObj) {
    return highlightObj.name;
  });
  var invalidHighlightNames = allowedHighlights.filter(function (highlightName) {
    return highlightNames.indexOf(highlightName) === -1;
  });
  chartHighlights = chartHighlights.filter(function (highlightObj) {
    return !allowedHighlights.includes(highlightObj.name);
  });

  let highlightOptions = [];

  for (var aHighlightIdx in chartHighlights) {
    let chartHighlight = chartHighlights[aHighlightIdx];
    let validOption = {};
    validOption.label = chartHighlight.name;
    validOption.value = chartHighlight.name;
    validOption.clickHandler = () => clickHandler("add", "allowedHighlights", chartHighlight.name);
    highlightOptions.push(validOption);
  }

  for (var i = 0; i < invalidHighlightNames.length; i++) {
    let aName = invalidHighlightNames[i];
    let invalidOption = {};
    invalidOption.label = aName;
    invalidOption.value = aName;
    invalidOption.clickHandler = () => clickHandler("add", "allowedHighlights", aName);
    invalidOption.icon = "alert";
    invalidOption.divider = i === 0;
    highlightOptions.push(invalidOption);
  }

  if (highlightOptions.length === 0) {
    return EmptyOptions;
  }

  return highlightOptions;
};

// FILTER CURRENT LIST
export const BuildAllowedFilterOptions = (theGroup, currentChart, clickHandler) => {
  let options = [];
  if (!currentChart || !theGroup) return options;
  let chartFilters = currentChart["filters"];
  if (!chartFilters?.length) return options;
  let chartID = currentChart["ID"];
  let filters = theGroup["allowedFilters"][chartID] || [];
  for (let i = 0; i < filters.length; i++) {
    let theFilter = theGroup["allowedFilters"][chartID][i];
    if (typeof theFilter === "object" && theFilter !== null && theFilter.filterName != null) {
      theFilter = theGroup["allowedFilters"][chartID][i].filterName;
      theGroup["allowedFilters"][chartID][i] = theFilter;
    }
    let option = {};
    option.value = theFilter;
    option.content = (
      <ActionListItem
        label={theFilter}
        labelProps={{ size: "small" }}
        actions={[
          {
            iconName: "trash-can",
            iconProps: { color: "error" },
            onClick: () => clickHandler("remove", "allowedFilters", theFilter),
            dataTestId: `${accessGroupsTestPrefix}-modal-filter-${theFilter}-remove-btn`
          }
        ]}
      />
    );
    options.push(option);
  }
  return options;
};

// SELECT FILTER OPTIONS
export const BuildSelectFilterOptions = (group, currentChart, clickHandler) => {
  let filterOptions = [];
  if (!currentChart || !group) return filterOptions;
  let chartID = currentChart["ID"];
  var allowedFilters = group["allowedFilters"][chartID] || [];
  var chartFilters = currentChart["filters"];
  if (!chartFilters) return filterOptions;
  var filterNames = chartFilters.map(function (filterObj) {
    return filterObj.filterName;
  });
  var unusedFilters = chartFilters.filter(function (filterName) {
    return filterNames.indexOf(filterName) === -1;
  });
  unusedFilters = unusedFilters.filter(function (filterName) {
    return !allowedFilters.includes(filterName.filterName);
  });
  for (var aFilterIdx in unusedFilters) {
    let chartFilter = unusedFilters[aFilterIdx];
    let option = {};
    option.value = chartFilter.filterName;
    option.label = chartFilter.filterName;
    option.clickHandler = () => clickHandler("add", "allowedFilters", chartFilter.filterName);
    filterOptions.push(option);
  }

  if (filterOptions.length === 0) {
    return EmptyOptions;
  }

  return filterOptions;
};

// VIEWS CURRENT LIST
export const BuildAllowedViewOptions = (theGroup, currentChart, clickHandler) => {
  let options = [];
  if (!currentChart || !theGroup || !theGroup["views"]) return options;
  let chartID = currentChart["ID"];
  let views = theGroup["views"][chartID];
  if (views == null) views = [];
  for (let i = 0; i < views.length; i++) {
    let theViewID = theGroup["views"][chartID][i];
    let viewName = GetViewNameByID(theViewID);
    let option = {};
    option.value = theViewID;
    option.content = (
      <ActionListItem
        label={viewName}
        labelProps={{ size: "small" }}
        actions={[
          {
            iconName: "trash-can",
            iconProps: { color: "error" },
            onClick: () => clickHandler("remove", "views", theViewID),
            dataTestId: `${accessGroupsTestPrefix}-modal-view-${theViewID}-remove-btn`
          }
        ]}
      />
    );
    options.push(option);
  }
  return options;
};

// VIEW SELECT OPTIONS
export const BuildSelectChartViewsOptions = (theGroup, currentChart, clickHandler) => {
  let options = [];
  if (!currentChart || !theGroup || !theGroup["views"]) return options;
  let currentChartID = currentChart["ID"];
  var allowedViews = theGroup["views"][currentChartID] || [];

  const wsMgr = GetWSMgr();
  const ctm = wsMgr.GetChartTemplatesMgr();

  let chartViews = currentChart["views"];
  chartViews = chartViews.filter(function (view) {
    return !allowedViews.includes(view);
  });
  let unusedViews = GetUnusedViews();
  unusedViews = unusedViews.filter(function (view) {
    return !allowedViews.includes(view);
  });

  let availableViews = [];
  for (let aViewIdx in chartViews) {
    let chartViewID = chartViews[aViewIdx];
    let theChartView = ctm.FindTemplateByIDAllSets(chartViewID, true)["template"];
    let theChartViewName = theChartView?.GetTemplateName();
    if (!theChartViewName) {
      theChartViewName = chartViewID + " (" + appstr("Missing") + ")";
    }
    let option = {};
    option.value = chartViewID;
    option.label = theChartViewName;
    option.clickHandler = () => clickHandler("add", "views", chartViewID);
    option.divider = unusedViews?.length > 0 && parseInt(aViewIdx) === chartViews.length - 1;
    availableViews.push(option);
  }
  for (let aUnusedIdx in unusedViews) {
    let unusedViewID = unusedViews[aUnusedIdx];
    let theView = ctm.FindTemplateByIDAllSets(unusedViewID, true)["template"];
    let unusedChartViewName = theView?.GetTemplateName();
    if (!unusedChartViewName) {
      unusedChartViewName = unusedViewID + " (" + appstr("Missing") + ")";
    }
    let unusedOption = {};
    unusedOption.value = unusedViewID;
    unusedOption.label = unusedChartViewName;
    unusedOption.clickHandler = () => clickHandler("add", "views", unusedViewID);
    availableViews.push(unusedOption);
  }

  if (availableViews.length === 0) {
    return EmptyOptions;
  }

  return availableViews;
};

export const AccessGroupModal = ({
  show,
  existingGroup,
  accountConfig,
  groups,
  onClose,
  isCreateNewGroup
}) => {
  const [editGroup, setEditGroup] = useState(null);
  const [clonedGroup, setClonedGroup] = useState(null);
  const [isNewGroup, setIsNewGroup] = useState(isCreateNewGroup);
  const [folders, setFolders] = useState([]);
  const [currentSelectedChart, setCurrentSelectedChart] = useState();
  const [changedFields, setChangedFields] = useState([]);
  const [errorStatus, setErrorStatus] = useState("");
  const [users, setUsers] = useState([]);

  const chartList = accountConfig["charts"];
  const accountInfo = accountConfig.account;
  const enabledReporting = accountInfo?.reporting;

  const LoadUsers = async () => {
    const { userList } = await GetUserList();
    setUsers(userList);
  };

  useEffect(() => {
    if (!currentSelectedChart) setCurrentSelectedChart(chartList[0]);
    InitializeGroup();
    LoadFolders();
    LoadUsers();
    let wsMgr = StateLib.GetWSMgr();
    const eventTracker = wsMgr.GetUsageTracker();
    eventTracker.ReportEvent("account_settings.access_group_editor.opened");
  }, []);

  const updateGroup = async data => {
    if (!data) return;
    const { result, success } = await UpdateAccountMetadata(data);
    if (result && success) {
      setClonedGroup(JSON.parse(JSON.stringify(editGroup)));
      clearDirty();
      onClose(editGroup, existingGroup);
    } else {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("groupupdateerr"), null, GetWSMgr(), true);
    }
  };

  const isChartData = IsChartData(accountConfig);
  let currentChartID = currentSelectedChart ? currentSelectedChart["ID"] : null;

  const LoadFolders = async () => {
    const { success, processedResults } = await LoadDirectory("", "folders");
    if (success) setFolders(processedResults);
  };

  const InitializeGroup = () => {
    let initGroup = null;
    if (existingGroup != null && groups[existingGroup] && !isNewGroup) {
      initGroup = groups[existingGroup];
    } else if (isNewGroup) {
      initGroup = GetNewGroupObj();
      setIsNewGroup(true);
    }
    if (initGroup != null) {
      setClonedGroup(JSON.parse(JSON.stringify(initGroup)));
      let initializedEditGroup = InitializeGroupSettings(JSON.parse(JSON.stringify(initGroup)));
      setEditGroup(initializedEditGroup);
    }
  };

  // TODO this stuff is already being initialized on the backend now. Leaving this here until we are comfortable removing
  const InitializeGroupSettings = group => {
    let g = group ? group : editGroup;
    let targetChart = currentSelectedChart ? currentSelectedChart : accountConfig?.charts[0];
    if (IsChartData(accountConfig) && g && targetChart) {
      let chartID = targetChart["ID"];
      var isBranchLevelSecurity = g["limitToSelf"] && g["limitToSelf"][chartID] != null;

      if (!isBranchLevelSecurity) {
        if (!g["limitToSelf"]) g["limitToSelf"] = {};
        g["limitToSelf"][chartID] = false;
      }

      var isChartAccess = g["chartAccess"] && g["chartAccess"][chartID] != null;
      if (!isChartAccess) {
        if (!g["chartAccess"]) g["chartAccess"] = {};
      }
      let allChartViews = GetAllChartViews(targetChart);
      var groupViews = g["views"] ? g["views"][chartID] : [];
      for (var aViewIdx in groupViews) {
        if (allChartViews.indexOf(groupViews[aViewIdx]) == -1)
          groupViews.splice(parseInt(aViewIdx), 1);
      }
      var allowedViews = g["views"];
      var viewsExist = allowedViews && allowedViews[chartID];
      if (!viewsExist) {
        if (!g["views"]) g["views"] = {};
        g["views"][chartID] = [];
      }

      var allowedFilters = g["allowedFilters"];
      var filtersExist = allowedFilters && allowedFilters[chartID];

      if (!filtersExist) {
        if (!g["allowedFilters"]) g["allowedFilters"] = {};
        var allowedFilterList = [];
        if (targetChart && targetChart["filters"])
          allowedFilterList = targetChart["filters"].map(function (aFilterObj) {
            return aFilterObj.filterName;
          });
        g["allowedFilters"][chartID] = allowedFilterList;
      }
      var allowedHighlights = g["allowedHighlights"];
      var highlightsExist = allowedHighlights && allowedHighlights[chartID];

      if (!highlightsExist) {
        if (!g["allowedHighlights"]) g["allowedHighlights"] = {};
        var allowedHighlightList = [];
        if (targetChart && targetChart["highlights"])
          allowedHighlightList = targetChart["highlights"].map(function (aHighlightObj) {
            return aHighlightObj.name;
          });
        g["allowedHighlights"][chartID] = allowedHighlightList;
      }
    }
    return g;
  };

  // TODO group intialization appears to no longer be necessary on the frontend - leaving here until we feel comfortable removing
  useEffect(() => {
    let newGroup = InitializeGroupSettings(editGroup);
    setEditGroup(prevState => {
      return { ...prevState, newGroup };
    });
  }, [currentSelectedChart]);

  const handleChange = (key, value) => {
    setEditGroup({
      ...editGroup,
      [key]: value
    });
    ChangedField(key);
  };

  const toggleValue = key => {
    handleChange(key, !editGroup[key]);
  };

  const ChangedField = key => {
    if (!changedFields.includes(key)) setChangedFields([...changedFields, key]);
  };

  const handleInputChange = e => {
    const value = e.target.value;
    const key = e.target.name;
    handleChange(key, value);
  };

  const checkDirty = () => {
    return changedFields?.length > 0;
  };

  const clearDirty = () => {
    setChangedFields([]);
  };

  const ChangeChart = o => {
    const charts = accountConfig.charts;
    let targetChart = null;
    for (let aChart of charts) {
      if (aChart["ID"] === o.value) {
        targetChart = aChart;
        break;
      }
    }
    if (targetChart != null) setCurrentSelectedChart(targetChart);
  };

  const onSaveGroup = () => {
    const { groupValid, msg } = CheckValidGroupConfig(accountConfig, editGroup);
    if (!groupValid) {
      setErrorStatus(msg);
      return;
    }
    setErrorStatus("");
    let updatedGroupList = SetAccessGroupsToJSON(accountConfig, editGroup, existingGroup);
    var curSecObj = accountConfig["security"];
    if (!curSecObj || !curSecObj["groups"]) var securityDump = { groups: updatedGroupList };
    else {
      curSecObj["groups"] = updatedGroupList;
      securityDump = curSecObj;
    }
    const theData = JSON.stringify({ security: securityDump });
    updateGroup(theData);
  };

  const onCancel = (skipDirtyCheck = false) => {
    const wsMgr = GetWSMgr();
    if (checkDirty() && !skipDirtyCheck) {
      wsMgr.CreateReactAlert(
        appstr("Save changes to") + editGroup["name"] + "?",
        appstr("All changes will be lost"),
        () => onSaveGroup(),
        () => onCancel(true),
        appstr("Save Changes"),
        appstr("Discard Changes")
      );
      return;
    }
    clearDirty();
    setEditGroup(clonedGroup);
    onClose(false);
  };

  const addFolder = target => {
    let folderName = target.value;
    let currentFolders = editGroup.folders;
    if (!currentFolders) currentFolders = [];
    let newFolder = {};
    newFolder["locked"] = true;
    newFolder["name"] = folderName;
    currentFolders.push(newFolder);
    handleChange("folders", currentFolders);
  };

  const onFolderChange = (mode, folderIdx) => {
    switch (mode) {
      case "remove":
        let currentFolders = [...editGroup.folders];
        currentFolders.splice(folderIdx, 1);
        handleChange("folders", currentFolders);
        break;
      case "toggleLock":
        let currentFolder = editGroup.folders[folderIdx];
        currentFolder.locked = !currentFolder.locked;
        editGroup.folders[folderIdx] = currentFolder;
        handleChange("folders", editGroup.folders);
        break;
    }
  };
  const onGeneralChange = (mode, value) => {
    switch (mode) {
      case "chartAccess":
        let chartID = currentSelectedChart["ID"];
        let curAccess = editGroup["chartAccess"][chartID];
        curAccess = !(curAccess === true);
        editGroup["chartAccess"][chartID] = curAccess;
        if (!curAccess) {
          editGroup["limitToSelf"][chartID] = false;
          // Also uncheck branch level security when chart access is removed
          if (editGroup["branchLevelSecurity"] && editGroup["branchLevelSecurity"][chartID]) {
            delete editGroup["branchLevelSecurity"][chartID];
          }
        }
        handleChange("chartAccess", editGroup["chartAccess"]);
        break;
    }
  };

  const onListChange = (mode, key, value) => {
    let chartID = currentSelectedChart["ID"];
    let allowedList = editGroup[key][chartID];
    let targetValue = value;
    switch (mode) {
      case "add":
        var valueAllowed = allowedList.indexOf(targetValue) > -1;
        if (valueAllowed) allowedList.splice(allowedList.indexOf(targetValue), 1);
        else allowedList.push(targetValue);
        editGroup[key][chartID] = allowedList;
        handleChange(key, editGroup[key]);
        break;
      case "remove":
        allowedList.splice(allowedList.indexOf(targetValue), 1);
        editGroup[key][chartID] = allowedList;
        handleChange(key, editGroup[key]);
        break;
    }
  };

  const BuildAllowedFolderOptions = () => {
    let options = [];
    const folderList = editGroup ? editGroup?.folders : [];
    const MissingDirTooltip = (
      <TooltipWrapper
        tooltipProps={{
          message: appstr("foldermoveddeleted")
        }}
      >
        <Alert severity="warning" children={appstrp("foldernotfound", " ")} showIcon={false} />
      </TooltipWrapper>
    );

    for (let i in folderList) {
      let folder = folderList[i];
      let option = {};
      const showFolderNotExists = folders.length > 0 && !folders.includes(folder.name);
      option.value = folder.name;
      option.label = kSpecialFolders.includes(folder.name.toLowerCase())
        ? appstr(folder.name)
        : folder.name;
      if (folder.name === "Masters") option.label = appstr("Backgrounds");
      option.content = (
        <ActionListItem
          label={option.label}
          labelProps={{ size: "small" }}
          actions={[
            {
              iconName: folder.locked ? "lock" : "lock-open",
              onClick: () => onFolderChange("toggleLock", i),
              dataTestId: `${accessGroupsTestPrefix}-modal-folder-${folder.name}-lock-btn`
            },
            {
              iconName: "trash-can",
              iconProps: { color: "error" },
              onClick: () => onFolderChange("remove", i),
              dataTestId: `${accessGroupsTestPrefix}-modal-folder-${folder.name}-remove-btn`
            }
          ]}
          contentAfter={showFolderNotExists ? MissingDirTooltip : null}
          className="ocn-access-groups-setting-edit"
        />
      );
      option.icon = folder.locked ? "lock" : "lock-open";
      options.push(option);
    }
    return options;
  };

  const GetAllowedFolders = () => {
    if (!editGroup) return [];
    return editGroup.folders.map(item => item.name);
  };

  const BuildFolderOptions = () => {
    let options = [];
    let currentAdded = GetAllowedFolders();
    if (!folders) return options;
    for (let folder of folders) {
      let option = {};
      if (currentAdded.includes(folder)) continue;
      option.value = folder;
      option.label = kSpecialFolders.includes(folder.toLowerCase()) ? appstr(folder) : folder;
      if (folder === "Masters") option.label = appstr("Backgrounds");
      option.clickHandler = addFolder;
      options.push(option);
    }
    return options;
  };

  const BuildSelectOptionsByKey = value => {
    switch (value) {
      case "uiprofile":
        return BuildUIProfileOptions(accountConfig, handleChange);
      case "roleassignment":
        const canAddSeats = CanAddSeats(users, null, groups);
        return BuildRoleAssignOptions(accountConfig, handleChange, canAddSeats);
      case "rowsecprofile":
        return BuildRowLevelOptions(accountConfig, handleChange);
      default:
        return [];
    }
  };

  const toggleBLS = () => {
    let chartID = currentSelectedChart["ID"];
    if (!editGroup["branchLevelSecurity"]) editGroup["branchLevelSecurity"] = {};
    if (!editGroup["branchLevelSecurity"][chartID])
      editGroup["branchLevelSecurity"][chartID] = true;
    //I intend to select BLS <<
    else delete editGroup["branchLevelSecurity"][chartID];
    handleChange("branchLevelSecurity", editGroup["branchLevelSecurity"]);
  };

  const updateBranchProfile = o => {
    let chartID = currentSelectedChart["ID"];
    if (!editGroup["branchLevelSecurity"]) editGroup["branchLevelSecurity"] = {};
    editGroup["branchLevelSecurity"][chartID] = o.value;
    handleChange("branchLevelSecurity", editGroup["branchLevelSecurity"]);
  };

  const GetBranchLevelText = () => {
    var branchSecProfiles = accountConfig["branchlevel"];
    if (!branchSecProfiles || !editGroup || !currentSelectedChart)
      var curText = appstr("No profiles defined");
    else {
      var theID = editGroup["branchLevelSecurity"][currentChartID];
      curText = appstr("Select a Profile");
      if (branchSecProfiles[theID] !== true && branchSecProfiles[theID])
        curText = branchSecProfiles[theID]["name"] ? branchSecProfiles[theID]["name"] : theID;
    }
    return curText;
  };

  let chartAccess = false;
  if (currentSelectedChart && editGroup)
    chartAccess = editGroup["chartAccess"] && editGroup["chartAccess"][currentChartID];
  const chartName =
    currentSelectedChart && isChartData ? currentSelectedChart["name"] : appstr("nochartsloaded");

  var branchLevelSet =
    editGroup &&
    editGroup["branchLevelSecurity"] &&
    editGroup["branchLevelSecurity"][currentChartID] != null;

  var branchLevel = branchLevelSet && chartAccess;
  var branchLevelActive = branchLevel && chartAccess; // TODO used to show bls profile selector

  var disableBLS = !chartAccess || !getFeatureAccess(enumFeaturesList.BLS);

  let curBLSProfile = null;
  if (branchLevelSet) curBLSProfile = editGroup["branchLevelSecurity"][currentSelectedChart["ID"]];

  const branchSecOptions = BuildBranchSecOptions(accountConfig, updateBranchProfile);
  const contentClass = "oc-modal-content";

  const getFilteredGeneralOptions = generalOptions => {
    let options = RoleRestrictedGeneralOptions(generalOptions);
    options = packageRestrictedGeneralOptions(options);
    return options;
  };

  const RoleRestrictedGeneralOptions = generalOptions => {
    if (editGroup?.roleassignment) {
      for (const option of generalOptions) {
        if (editGroup.roleassignment === "ROUser") {
          option.disabled = ["pointintime", "canEditTemplates", "privatefolderaccess"].includes(
            option.value
          );
          if (option.disabled && editGroup[option.value] == true) {
            handleChange(option.value, !editGroup[option.value]);
          }
          if (option.disabled) {
            option.disabledReason = appstr(
              "This option is disabled due to role assignment restrictions"
            );
          }
        } else {
          option.disabled = false;
        }
      }
    }
    if (!editGroup?.roleassignment) {
      for (const option of generalOptions) {
        option.disabled = false;
      }
    }
    return generalOptions;
  };

  const packageRestrictedGeneralOptions = generalOptions => {
    if (!getFeatureAccess(enumFeaturesList.PIT)) {
      generalOptions = generalOptions.map(o => {
        if (o.value === "pointintime") {
          // Show the restriction without rewriting the group: the stored false outlived the
          // restriction and kept the group locked out once the entitlement came back.
          return {
            ...o,
            disabled: true,
            disabledReason: appstr("This option is disabled due to package restrictions")
          };
        }
        return o;
      });
    }
    return generalOptions;
  };

  let generalOptions = getFilteredGeneralOptions(GeneralOptions);

  return (
    <CentralizedModalContainer show={show}>
      <Modal
        id="example-modal"
        show={show}
        centerScreen={true}
        fullScreen={true}
        className={"oc-modal-full-screen"}
      >
        <DialogTitle
          divider={true}
          onClose={() => onCancel()}
          data-testid="account-settings-access-groups-modal-close-btn"
        >
          <span className={"ocn-explorer-icon-label"}>
            <Icon size={"medium"} name={isNewGroup ? "user-plus" : "user-pen"} />
            {isNewGroup ? appstr("Create new group") : appstr("Edit group")}
          </span>
        </DialogTitle>
        <DialogContent customContentClass={"oc-modal-content-container"}>
          <Flex direction={"column"} gap={"8px"} className={contentClass} height={"50%"}>
            {errorStatus && errorStatus.length > 0 && (
              <Text modifier={"medium"} colorModifier={"error"} status={"error"}>
                {errorStatus}
              </Text>
            )}
            <Input
              label={appstr("Name")}
              name={"name"}
              placeholder={appstr("Name")}
              size={"medium"}
              value={editGroup?.name}
              onChange={handleInputChange}
              dataTestId="account-settings-access-groups-modal-name-input"
            />
            <Flex justifyContent={"space-between"} overflow={"hidden"} gap={"24px"}>
              <Flex direction={"column"} gap={"8px"} flex={"1"}>
                <Text modifier={"medium"} size={"medium"}>
                  {appstr("Application Security")}
                </Text>
                <Flex
                  direction={"column"}
                  gap={"12px"}
                  padding={"8px 16px"}
                  className={cx("oc-list-container", "ocn-list-scrollbar")}
                >
                  {generalOptions.map((option, index) => {
                    return (
                      <Flex key={option.label} direction={"column"} gap={"12px"}>
                        <TooltipWrapper
                          tooltipProps={
                            option.disabled
                              ? {
                                  message: option.disabledReason,
                                  position: "bottom-start"
                                }
                              : ""
                          }
                        >
                          <Checkbox
                            checked={editGroup ? editGroup[option.value] : false}
                            id={"ag-general-security-cb-" + index}
                            data-testid={`account-settings-access-groups-modal-app-security-${option.value}-checkbox`}
                            label={appstr(option.label)}
                            onToggle={() => toggleValue(option.value)}
                            size={"medium"}
                            disabled={option.disabled}
                          />
                        </TooltipWrapper>
                      </Flex>
                    );
                  })}
                  {enabledReporting &&
                    ReportingOptions.map((option, index) => {
                      return (
                        <Flex key={option.label} direction={"column"} gap={"12px"}>
                          <Checkbox
                            checked={editGroup ? editGroup[option.value] : false}
                            id={"ag-general-reporting-cb-" + index}
                            data-testid={`account-settings-access-groups-modal-reporting-${option.value}-checkbox`}
                            label={appstr(option.label)}
                            onToggle={() => toggleValue(option.value)}
                            size="medium"
                          />
                        </Flex>
                      );
                    })}
                  {SecurityOptions.map((option, index) => {
                    let isChecked = editGroup
                      ? editGroup[option.value] !== false && editGroup[option.value] != null
                      : false;
                    let selectKey = option.selectKey;
                    return (
                      <Flex
                        key={option.label}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                      >
                        <Flex width={"100%"}>
                          <Checkbox
                            id={"ag-adv-security-cb-" + option.value}
                            data-testid={`account-settings-access-groups-modal-adv-security-${option.value}-checkbox`}
                            disabled={!getFeatureAccess(option.featureKey)}
                            checked={isChecked}
                            label={appstr(option.label)}
                            onToggle={() => toggleValue(option.value)}
                            size="medium"
                          />
                        </Flex>
                        {isChecked && getFeatureAccess(option.featureKey) && (
                          <Select
                            key={index}
                            placeholder={option.label}
                            value={editGroup ? editGroup[selectKey] : 0}
                            options={BuildSelectOptionsByKey(option.selectKey)}
                            popoverProps={{
                              flipOptions: {
                                mainAxis: false
                              }
                            }}
                            dataTestId={`account-settings-access-groups-modal-adv-security-${option.value}-select`}
                          />
                        )}
                      </Flex>
                    );
                  })}
                </Flex>
              </Flex>
              <Flex gap={"24px"} width={"50%"} height={"100%"}>
                <Flex
                  direction={"column"}
                  padding={"0px 2px"}
                  gap={"4px"}
                  width={"100%"}
                  overflow={"hidden"}
                  height={"100%"}
                >
                  <Text modifier={"medium"} size={"small"}>
                    {appstr("Allowed folders")}
                  </Text>
                  <Select
                    options={BuildFolderOptions()}
                    placeholder={appstr("Add folder")}
                    popoverProps={{
                      flipOptions: {
                        mainAxis: false
                      }
                    }}
                    dataTestId="account-settings-access-groups-modal-add-folder-select"
                  />
                  <div className={cx("oc-list-container", "ocn-list-scrollbar")}>
                    <List
                      enableVirtualization={false}
                      coloredSelection={true}
                      showCheck={false}
                      value={0}
                      optionSize={"small"}
                      options={BuildAllowedFolderOptions()}
                      listWidth="fill"
                    />
                  </div>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
          <Flex direction={"column"} gap={"8px"} height={"50%"} overflow={"hidden"}>
            <Divider />
            <Text modifier={"medium"} size={"medium"}>
              {appstr("Chart Security")}
            </Text>
            <Flex gap={"16px"} flex={"1"} overflow={"hidden"}>
              <Flex direction={"column"} flex={1} gap={"12px"}>
                <Flex direction={"column"} gap={"4px"}>
                  <Text modifier={"medium"} size={"small"}>
                    {appstr("Choose a base chart:")}
                  </Text>
                  <Select
                    label={chartName}
                    placeholder={appstr("Select chart to configure")}
                    value={currentSelectedChart ? currentSelectedChart["ID"] : null}
                    options={BuildBaseCharts(accountConfig["charts"], editGroup, ChangeChart)}
                    popoverProps={{
                      flipOptions: {
                        mainAxis: false
                      }
                    }}
                    dataTestId="account-settings-access-groups-modal-base-chart-select"
                  />
                </Flex>
                <Checkbox
                  id={"ag-chart-access-cb"}
                  data-testid="account-settings-access-groups-modal-chart-access-checkbox"
                  checked={chartAccess}
                  label={appstr("Can access chart")}
                  onToggle={() => onGeneralChange("chartAccess")}
                  size="medium"
                />
                <Checkbox
                  id={"ag-bls-cb"}
                  data-testid="account-settings-access-groups-modal-bls-checkbox"
                  checked={branchLevelSet}
                  disabled={disableBLS}
                  label={appstr("Branch level security")}
                  onToggle={toggleBLS}
                  size="medium"
                />
                {branchLevelActive && (
                  <Select
                    disabled={branchSecOptions.length == 0}
                    placeholder={GetBranchLevelText()}
                    value={curBLSProfile}
                    options={branchSecOptions}
                    popoverProps={{
                      flipOptions: {
                        mainAxis: false
                      }
                    }}
                    dataTestId="account-settings-access-groups-modal-bls-profile-select"
                  />
                )}
              </Flex>

              <Flex gap={"24px"} flex={1} height={"100%"}>
                <Flex direction={"column"} gap={"4px"} width={"100%"} height={"100%"}>
                  <Flex direction={"column"} gap={"4px"} height={"100%"}>
                    <Text modifier={"medium"} size={"small"}>
                      {appstr("Allowed views")}
                    </Text>
                    <Select
                      disabled={!chartAccess}
                      options={BuildSelectChartViewsOptions(
                        editGroup,
                        currentSelectedChart,
                        onListChange
                      )}
                      placeholder={appstr("addtemplate")}
                      popoverProps={{
                        flipOptions: {
                          mainAxis: false
                        }
                      }}
                      dataTestId="account-settings-access-groups-modal-add-view-select"
                    />
                    <div className={cx("oc-list-container", "ocn-list-scrollbar")}>
                      <List
                        enableVirtualization={false}
                        coloredSelection={true}
                        showCheck={false}
                        value={0}
                        optionSize={"small"}
                        options={BuildAllowedViewOptions(
                          editGroup,
                          currentSelectedChart,
                          onListChange
                        )}
                        listWidth="fill"
                      />
                    </div>
                  </Flex>
                </Flex>
              </Flex>

              {currentSelectedChart?.["filters"]?.length > 0 && (
                <Flex gap={"24px"} flex={1} height={"100%"}>
                  <Flex direction={"column"} gap={"4px"} width={"100%"} height={"100%"}>
                    <Flex direction={"column"} gap={"4px"} height={"100%"}>
                      <Text modifier={"medium"} size={"small"}>
                        {appstr("Allowed legacy filters")}
                      </Text>
                      <Select
                        options={BuildSelectFilterOptions(
                          editGroup,
                          currentSelectedChart,
                          onListChange
                        )}
                        disabled={
                          !chartAccess ||
                          !(
                            currentSelectedChart &&
                            currentSelectedChart["filters"] &&
                            currentSelectedChart["filters"].length > 0
                          )
                        }
                        placeholder={appstr("Add filters")}
                        popoverProps={{
                          flipOptions: {
                            mainAxis: false
                          }
                        }}
                        dataTestId="account-settings-access-groups-modal-add-filter-select"
                      />
                      <div className={cx("oc-list-container", "ocn-list-scrollbar")}>
                        <List
                          enableVirtualization={false}
                          coloredSelection={true}
                          showCheck={false}
                          value={0}
                          optionSize={"small"}
                          options={BuildAllowedFilterOptions(
                            editGroup,
                            currentSelectedChart,
                            onListChange
                          )}
                          listWidth="fill"
                        />
                      </div>
                    </Flex>
                  </Flex>
                </Flex>
              )}

              {currentSelectedChart?.["highlights"]?.length > 0 && (
                <Flex gap={"24px"} flex={1} height={"100%"}>
                  <Flex direction={"column"} gap={"4px"} width={"100%"} height={"100%"}>
                    <Flex direction={"column"} gap={"4px"} height={"100%"}>
                      <Text modifier={"medium"} size={"small"}>
                        {appstr("Allowed legacy highlights")}
                      </Text>
                      <Select
                        disabled={
                          !chartAccess ||
                          !(
                            currentSelectedChart &&
                            currentSelectedChart["highlights"] &&
                            currentSelectedChart["highlights"].length > 0
                          )
                        }
                        options={BuildSelectHighlightOptions(
                          editGroup,
                          currentSelectedChart,
                          onListChange
                        )}
                        placeholder={appstr("Add highlights")}
                        popoverProps={{
                          flipOptions: {
                            mainAxis: false
                          }
                        }}
                        dataTestId="account-settings-access-groups-modal-add-highlight-select"
                      />
                      <div className={cx("oc-list-container", "ocn-list-scrollbar")}>
                        <List
                          enableVirtualization={false}
                          coloredSelection={true}
                          showCheck={false}
                          value={0}
                          optionSize={"small"}
                          options={BuildAllowedHighlightOptions(
                            editGroup,
                            currentSelectedChart,
                            onListChange
                          )}
                          listWidth="fill"
                        />
                      </div>
                    </Flex>
                  </Flex>
                </Flex>
              )}
            </Flex>
          </Flex>
        </DialogContent>
        <DialogActions divider={true}>
          <DialogActions.Tertiary
            onClick={() => onCancel()}
            dataTestId="account-settings-access-groups-modal-cancel-btn"
          >
            {appstr("Cancel")}
          </DialogActions.Tertiary>
          <DialogActions.Primary
            onClick={() => onSaveGroup()}
            dataTestId="account-settings-access-groups-modal-save-btn"
          >
            {isNewGroup ? appstr("Create") : appstr("Save")}
          </DialogActions.Primary>
        </DialogActions>
      </Modal>
    </CentralizedModalContainer>
  );
};

const BuildUIProfileOptions = (accountConfig, clickHandler) => {
  let profileOptions = [];
  if (!accountConfig) return profileOptions;

  const UIProfileList = Object.keys(accountConfig["uiprofiles"]);
  for (let aProfileIdx in UIProfileList) {
    let aProfile = UIProfileList[aProfileIdx];
    let option = {};
    option.label = aProfile;
    option.value = aProfile;
    option.clickHandler = () => clickHandler("uiprofile", aProfile);
    profileOptions.push(option);
  }
  return profileOptions;
};

const BuildRoleAssignOptions = (accountConfig, clickHandler, canAddSeats = false) => {
  let roleOptions = [];
  if (!accountConfig) return roleOptions;
  const roleList = [kROUser, kRWUser, kAdminUser];
  for (let role of roleList) {
    let option = {};
    option.value = role;
    var label;
    switch (role) {
      case kAdminUser:
        label = appstr("adminuser2");
        break;
      case kROUser:
        label = appstr("readonlyuser");
        break;
      case kRWUser:
        label = appstr("readwriteuser");
        break;
      default:
        break;
    }
    option.label = label;
    option.clickHandler = () => clickHandler("roleassignment", role);
    option.disabled = role != kROUser && !canAddSeats;
    roleOptions.push(option);
  }
  return roleOptions;
};

const BuildRowLevelOptions = (accountConfig, clickHandler) => {
  let profileOptions = [];
  if (!accountConfig) return profileOptions;
  var rowLevelSecList = accountConfig["security"]["rowlevel"];
  let dynamicOption = {
    label: "Dynamic",
    value: "_dynamic",
    clickHandler: () => clickHandler("rowsecprofile", "_dynamic")
  };
  profileOptions.push(dynamicOption);
  for (let aRowSecIdx in rowLevelSecList) {
    var theProfile = rowLevelSecList[aRowSecIdx];
    let option = {};
    option.label = theProfile["name"] ? theProfile["name"] : aRowSecIdx;
    option.value = aRowSecIdx;
    option.clickHandler = () => clickHandler("rowsecprofile", aRowSecIdx);
    profileOptions.push(option);
  }
  return profileOptions;
};

const BuildBranchSecOptions = (accountConfig, clickHandler) => {
  var branchSec = {};
  if (accountConfig["security"] && accountConfig["security"]["branchlevel"])
    branchSec = accountConfig["security"]["branchlevel"];
  let options = [];
  for (let profileID in branchSec) {
    var theProfile = branchSec[profileID];
    let option = {};
    option.value = profileID;
    option.label = theProfile["name"] ? theProfile["name"] : profileID;
    option.clickHandler = clickHandler;
    options.push(option);
  }
  return options;
};
